import React, { useEffect, useRef, useState } from 'react'
import { BsFillPlayFill, BsPauseFill, BsStopFill, BsPencilSquare, BsQuestionLg } from 'react-icons/bs'

const WiscIVVerbal = ({access, counts, images, setScore}) => {
 
    const [showStartButton, setShowStartButton] = useState(false)
    const [showNextButton, setShowNextButton] = useState(false)
    const [show0Score, setShow0Score] = useState(false)
    const [show1Score, setShow1Score] = useState(false)
    const [show2Score, setShow2Score] = useState(false)
 

    

    

    useEffect(() => {
        
        if (counts == 0) {
            setShowStartButton(true)
        } else {
            setShowStartButton(false)
        }
        if (counts == 1 || counts == 2 || counts == 3) {
            setShowNextButton(true)
        } else {
            setShowNextButton(false)
        }
        if (counts > 3) {
            setShow0Score(true)
            setShow1Score(true)
        } else {
            setShow0Score(false)
            setShow1Score(false)
        }
        
    }, [counts])

    if (access != "User") {
        return (
            <div className='test-container'>
                <div className='container-screening-question' style={{height: '45%'}}>
                    <div className='screening-test-question' style={{flexDirection: 'column', alignItems: 'center', background: '#b3e0ff'}}>
                        <img src={images[counts].image} style={{maxWidth: '80%', overflowY: 'auto'}}></img>
                    </div>
                </div>
                <div className='container-screening-answer' style={{height: '50%', justifyContent: 'center'}}>
                    {show2Score &&
                    <button onClick={() => setScore(2)} className='screening-answer-option mode-bg-11'>{"دو نمره"}</button>
                    }
                    {show1Score &&
                    <button onClick={() => setScore(1)} className='screening-answer-option mode-bg-11'>{"یک نمره"}</button>
                    }
                    {show0Score &&
                    <button onClick={() => setScore(0)} className='screening-answer-option mode-bg-11'>{"صفر نمره"}</button>
                    }
                    {showNextButton &&
                    <button onClick={() => setScore(0)} className='screening-answer-option mode-bg-11'>{"بعدی"}</button>
                    }
                    {showStartButton &&
                    <button onClick={() => setScore(0)} className='screening-answer-option mode-bg-11'>{"شروع"}</button>
                    }
                </div>
            </div>
        )
    }

    return (
        <div className='test-container'>
            <div className='container-screening-question h-100'>
                <div className='screening-test-question' style={{flexDirection: 'column', alignItems: 'center', marginTop: '1.75em', marginBottom: '1.75em', background: '#b3e0ff'}}>
                    <img src={images[counts].image} style={{maxWidth: '80%', overflowY: 'auto'}}></img>
                </div>
            </div>
        </div>
    )
}

export default WiscIVVerbal